export interface Avatar {
  id: string;
  name: string;
  url: string;
}

export const PREDEFINED_AVATARS: Avatar[] = [
  {
    id: 'male1',
    name: 'Male 1',
    url: '/api/avatars/male1.png'
  },
  {
    id: 'male2',
    name: 'Male 2',
    url: '/api/avatars/male2.png'
  },
  {
    id: 'female1',
    name: 'Female 1',
    url: '/api/avatars/female1.png'
  },
  {
    id: 'female2',
    name: 'Female 2',
    url: '/api/avatars/female2.png'
  },
  {
    id: 'person1',
    name: 'Person 1',
    url: '/api/avatars/person1.png'
  },
  {
    id: 'person2',
    name: 'Person 2',
    url: '/api/avatars/person2.png'
  },
  {
    id: 'person3',
    name: 'Person 3',
    url: '/api/avatars/person3.png'
  },
  {
    id: 'person4',
    name: 'Person 4',
    url: '/api/avatars/person4.png'
  },
  {
    id: 'person5',
    name: 'Person 5',
    url: '/api/avatars/person5.png'
  },
  {
    id: 'person6',
    name: 'Person 6',
    url: '/api/avatars/person6.png'
  },
  {
    id: 'person7',
    name: 'Person 7',
    url: '/api/avatars/person7.png'
  },
  {
    id: 'person8',
    name: 'Person 8',
    url: '/api/avatars/person8.png'
  }
];